import { Companion_instancercv49ep9xa3t as Companion_instance } from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionPipe.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Builder3lcn00uc5gcy3 as Builder } from '../../../../../apollo-kotlin-apollo-runtime/com/apollographql/apollo/ApolloClient.mjs';
import { ktorClient27akr7bvktwel as ktorClient } from '../../../../../apollo-kotlin-ktor-support-apollo-engine-ktor/com/apollographql/ktor/KtorExtensions.mjs';
import { DispatcherPipeCannon3aitdk4bdtfxf as DispatcherPipeCannon } from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionCannon.mjs';
import {
  perform1rf0a2z80o7fg as perform,
  SdkBoost3eue7fgosgz0d as SdkBoost,
} from './SdkBoost.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  perform2es0c2ae6217b as perform_0,
  SdkCreateSecretCommandDispatcher1ii7hep4t7p2 as SdkCreateSecretCommandDispatcher,
} from './SdkCreateSecretCommandDispatcher.mjs';
import {
  perform2zhzf7weh1vnd as perform_1,
  SdkDeletePairAssignmentsCommandDispatcher3r89xhj6g83sl as SdkDeletePairAssignmentsCommandDispatcher,
} from './SdkDeletePairAssignmentsCommandDispatcher.mjs';
import {
  perform39szuk57ufmau as perform_2,
  SdkDeletePartyCommandDispatcher27loij2ye5nr9 as SdkDeletePartyCommandDispatcher,
} from './SdkDeletePartyCommandDispatcher.mjs';
import {
  perform3jhtz3gq8ra7d as perform_3,
  SdkDeletePinCommandDispatcher31mrzwlipmcuz as SdkDeletePinCommandDispatcher,
} from './SdkDeletePinCommandDispatcher.mjs';
import {
  perform3ecdiayucun80 as perform_4,
  SdkDeletePlayerCommandDispatcher2rxhmptx7gljw as SdkDeletePlayerCommandDispatcher,
} from './SdkDeletePlayerCommandDispatcher.mjs';
import {
  performc8dafn9l91q6 as perform_5,
  SdkDeleteSecretCommandDispatcher1wzqb0vkuors as SdkDeleteSecretCommandDispatcher,
} from './SdkDeleteSecretCommandDispatcher.mjs';
import {
  perform3pwdogs48g0kz as perform_6,
  SdkGrantDiscordAccessjjorbkvtrfx9 as SdkGrantDiscordAccess,
} from './SdkGrantDiscordAccess.mjs';
import {
  perform3c6sf47snob1x as perform_7,
  SdkGrantSlackAccess15ga4e1z55nsr as SdkGrantSlackAccess,
} from './SdkGrantSlackAccess.mjs';
import {
  perform2q29klyh5l8u as perform_8,
  SdkGraphQueryDispatcher2qog4v6gbj5of as SdkGraphQueryDispatcher,
} from './SdkGraphQueryDispatcher.mjs';
import {
  perform36hp3lo09iydn as perform_9,
  SdkSavePairAssignmentsCommandDispatcher3ocpuomh8jp9i as SdkSavePairAssignmentsCommandDispatcher,
} from './SdkPairAssignmentDocumentSave.mjs';
import {
  perform7mh21y7i2qpg as perform_10,
  SdkSavePartyCommandDispatcher1x5cidvmu3vb0 as SdkSavePartyCommandDispatcher,
} from './SdkSavePartyCommandDispatcher.mjs';
import {
  perform3pf84jpgzmm3h as perform_11,
  SdkSavePinCommandDispatcher1w2xmq7bhdmfl as SdkSavePinCommandDispatcher,
} from './SdkSavePinCommandDispatcher.mjs';
import {
  perform161737cslumnq as perform_12,
  SdkSavePlayerCommandDispatcher2k2b5uhezxdlq as SdkSavePlayerCommandDispatcher,
} from './SdkSavePlayerCommandDispatcher.mjs';
import {
  perform38cqpzdyp6lp as perform_13,
  SdkSaveSlackIntegrationCommandDispatcher1t7cxnysmjc4h as SdkSaveSlackIntegrationCommandDispatcher,
} from './SdkSaveSlackIntegrationCommandDispatcher.mjs';
import {
  perform1gxruvgzh3z45 as perform_14,
  SdkSpin3glo2r2cb0vqe as SdkSpin,
} from './SdkSpin.mjs';
import {
  executermm52fqenh80 as execute,
  GqlTrait2wtoeyl3yfalb as GqlTrait,
} from './gql/GqlTrait.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher_0 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher_1 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { Dispatcher2txct93ff9b99 as Dispatcher_2 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher_3 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher_4 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher_5 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher_6 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher_7 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher_8 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { Dispatcher2xvjdz9qh940 as Dispatcher_9 } from './gql/GqlQuery.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher_10 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { Dispatcher3ngwv5mtnm33a as Dispatcher_11 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher_12 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { Dispatchernurlbopdkn3a as Dispatcher_13 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher_14 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  apolloMutation1pfb2yrb4utuy as apolloMutation,
  apolloQuery1ngnajaedsnmj as apolloQuery,
  KtorQueryPerformer3enpohylr2sy5 as KtorQueryPerformer,
} from './gql/KtorQueryPerformer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function couplingSdk(getIdTokenFunc, httpClient, pipe) {
  pipe = pipe === VOID ? Companion_instance : pipe;
  return new (DispatcherPipeCannon())(new (KtorCouplingSdkDispatcher())(getIdTokenFunc, httpClient, ktorClient((new (Builder())()).i65('/api/graphql'), httpClient).d38()), pipe);
}
var KtorCouplingSdkDispatcherClass;
function KtorCouplingSdkDispatcher() {
  if (KtorCouplingSdkDispatcherClass === VOID) {
    class $ {
      constructor(getIdTokenFunc, httpClient, apolloClient) {
        this.m6s_1 = getIdTokenFunc;
        this.n6s_1 = new (StandardPartyGQLPerformer())(this.m6s_1, httpClient, apolloClient);
      }
      o6s() {
        return this.n6s_1;
      }
      f2h(command, $completion) {
        return this.p6s(command, $completion);
      }
      d2i(command, $completion) {
        return this.r6s(command, $completion);
      }
      s2i(command, $completion) {
        return this.s6s(command, $completion);
      }
      y2i(command, $completion) {
        return this.t6s(command, $completion);
      }
    }
    protoOf($).p6s = perform;
    protoOf($).b2j = perform_0;
    protoOf($).x2h = perform_1;
    protoOf($).g2i = perform_2;
    protoOf($).p2i = perform_3;
    protoOf($).v2i = perform_4;
    protoOf($).e2j = perform_5;
    protoOf($).i2h = perform_6;
    protoOf($).l2h = perform_7;
    protoOf($).q6s = perform_8;
    protoOf($).r6s = perform_9;
    protoOf($).j2i = perform_10;
    protoOf($).s6s = perform_11;
    protoOf($).t6s = perform_12;
    protoOf($).m2i = perform_13;
    protoOf($).o2h = perform_14;
    protoOf($).u6s = execute;
    initMetadataForClass($, 'KtorCouplingSdkDispatcher', VOID, VOID, [Dispatcher(), Dispatcher_0(), Dispatcher_1(), Dispatcher_2(), Dispatcher_3(), Dispatcher_4(), Dispatcher_5(), Dispatcher_6(), Dispatcher_7(), Dispatcher_8(), Dispatcher_9(), Dispatcher_10(), Dispatcher_11(), Dispatcher_12(), Dispatcher_13(), Dispatcher_14(), SdkBoost(), GqlTrait(), SdkCreateSecretCommandDispatcher(), SdkDeletePairAssignmentsCommandDispatcher(), SdkDeletePartyCommandDispatcher(), SdkDeletePinCommandDispatcher(), SdkDeletePlayerCommandDispatcher(), SdkDeleteSecretCommandDispatcher(), SdkGrantDiscordAccess(), SdkGrantSlackAccess(), SdkGraphQueryDispatcher(), SdkSavePairAssignmentsCommandDispatcher(), SdkSavePartyCommandDispatcher(), SdkSavePinCommandDispatcher(), SdkSavePlayerCommandDispatcher(), SdkSaveSlackIntegrationCommandDispatcher(), SdkSpin()], [1]);
    KtorCouplingSdkDispatcherClass = $;
  }
  return KtorCouplingSdkDispatcherClass;
}
var StandardPartyGQLPerformerClass;
function StandardPartyGQLPerformer() {
  if (StandardPartyGQLPerformerClass === VOID) {
    class $ {
      constructor(getIdTokenFunc, httpClient, apolloClient) {
        this.v6s_1 = getIdTokenFunc;
        this.w6s_1 = apolloClient;
        this.x6s_1 = httpClient;
      }
      y6s() {
        return this.w6s_1;
      }
      *z6s($completion) {
        return yield* this.v6s_1($completion);
      }
    }
    protoOf($).a6t = apolloMutation;
    protoOf($).b6t = apolloQuery;
    initMetadataForClass($, 'StandardPartyGQLPerformer', VOID, VOID, [KtorQueryPerformer()], [0, 1]);
    StandardPartyGQLPerformerClass = $;
  }
  return StandardPartyGQLPerformerClass;
}
//region block: exports
export {
  couplingSdk as couplingSdk1kvwqabhypuft,
};
//endregion

//# sourceMappingURL=KtorSdk.mjs.map
